import { render, staticRenderFns } from "./reportmaster-screen.vue?vue&type=template&id=1631b6c3&"
import script from "./reportmaster-screen.vue?vue&type=script&lang=js&"
export * from "./reportmaster-screen.vue?vue&type=script&lang=js&"
import style0 from "./reportmaster-screen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports